"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.factoryUseCookie = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _shallowEqual = require("../utils/shallowEqual");

var factoryUseCookie = function factoryUseCookie(RealTimeCookie, Cookie) {
  return function useCookie(select) {
    var newSelect = select !== null && select !== void 0 ? select : function (cookie) {
      return cookie;
    };

    var selectMemo = _react.default.useRef(newSelect);

    selectMemo.current = newSelect;

    var _React$useState = _react.default.useState(function () {
      return selectMemo.current(Cookie.get());
    }),
        _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
        value = _React$useState2[0],
        setValue = _React$useState2[1];

    var prevValue = _react.default.useRef(value);

    _react.default.useEffect(function () {
      var handler = function handler(state) {
        var newValue = selectMemo.current(state);

        if (!(0, _shallowEqual.shallowEqual)(prevValue.current, newValue)) {
          setValue(newValue);
          prevValue.current = newValue;
        }
      };

      RealTimeCookie.addListener(handler);
      return function () {
        return RealTimeCookie.removeListener(handler);
      };
    }, []);

    return value;
  };
};

exports.factoryUseCookie = factoryUseCookie;